// extracted by mini-css-extract-plugin
export var svg = "AlmaSymbol-module--svg--GqL8L";
export var wrap = "AlmaSymbol-module--wrap--ivDRM composers-module--unButton--9ZYj7";